import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import { pasteConfirmLines } from './useTranscriptClipboard';

/** In-app confirmation before the Paste button overwrites / pastes suspicious text. */
export default function PasteConfirmDialog({ reasons, onConfirm, onCancel }) {
  const open = Array.isArray(reasons) && reasons.length > 0;
  const otherTask = open && reasons.includes('other-task');
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      aria-labelledby="qc-paste-confirm-title"
      // Must sit above the fullscreen QC assessment modal (zIndex.modal + 100_000).
      slotProps={{
        root: { sx: (theme) => ({ zIndex: theme.zIndex.modal + 100_002 }) },
      }}
    >
      <DialogTitle
        id="qc-paste-confirm-title"
        sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '1rem', fontWeight: 700 }}
      >
        <WarningAmberRounded sx={{ color: 'warning.main' }} />
        {otherTask ? 'Paste text from another task?' : 'Replace the updated transcript?'}
      </DialogTitle>
      <DialogContent>
        {open
          ? pasteConfirmLines(reasons).map((line) => (
              <DialogContentText key={line} sx={{ fontSize: '0.875rem', mb: 1 }}>
                {line}
              </DialogContentText>
            ))
          : null}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} autoFocus>
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="warning" disableElevation>
          Paste anyway
        </Button>
      </DialogActions>
    </Dialog>
  );
}
